import { createSlice } from "@reduxjs/toolkit";

import {
  DICTIONARIES_REDUCER,
  loadCitiesAction,
} from "store/dictionaries/dictionaries.actions";
import { ICity } from "types/dictionaries.types";

type DictionariesReducer = {
  cities: {
    items: ICity[]
    loading: boolean;
  }
}

const initialState: DictionariesReducer = {
  cities: {
    items: [],
    loading: false,
  },
}

export const dictionariesSlice = createSlice({
  name: DICTIONARIES_REDUCER,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(loadCitiesAction.trigger, ({ cities }) => {
        cities.loading = true
      })
      .addCase(loadCitiesAction.resolved, ({ cities }, { payload }) => {
        cities.items = payload
        cities.loading = false
      })
      .addCase(loadCitiesAction.rejected, ({ cities }) => {
        cities.loading = false
      })
  }
});

export default dictionariesSlice.reducer